var WCompass = {
	node :null,

	direction: function(x1,y1, x2, y2) { 
		const y = Math.sin(y2-y1) * Math.cos(x2);
		const x = Math.cos(x1)*Math.sin(x2) -
          Math.sin(x1)*Math.cos(x2)*Math.cos(y2-y1);
		const θ = Math.atan2(y, x);
		const brng = (θ*180/Math.PI + 360) % 360; // in degrees
    	return brng;
    },

    spotDirection: function(idx) {
    	var dest = player.current.properties.spots[idx].place;
    	return WCompass.direction(player.current.gps_x, player.current.gps_y, dest.gps_x, dest.gps_y);
    },

    hasCoordinates: function(spot) {
    	if (spot.place.gps_x != undefined && spot.place.gps_y != undefined && player.current.gps_x != undefined && player.current.gps_y != undefined) return true;
    	return false;
    },

    calculateNorth: function() {
    	var dir; 
    	var spotdir;
    	var dumps = [];
    	var avg = 0;
    	var sum = 0;
    	var count = 0;

    	for(var s in player.current.properties.spots) {
    		var dest = player.current.properties.spots[s];
    		if (!WCompass.hasCoordinates(dest)) continue;
    		count ++;
    		spotdir = (dest.x + 95) % 360;
    		if (spotdir < 0) spotdir = 360 + spotdir;

    		dir = WCompass.spotDirection(s);
    		sum = spotdir - dir;
    		if (sum < 0) sum = 360 + sum;

    		var out = {"key": s, "x": spotdir, "dir": dir, "north": sum, "name": dest.fullName};
    		avg += sum;
    		
    		return avg;
//    		dumps.push(out);
    	}

    	return 0;
    	//console.log(dumps);
    	//console.log("NORTH: " + avg / count);
    },

	init: function() {
		WCompass.node = $("<div id='compass'></div>");
		WCompass.node.append(TPL.render("compass-main", {}));
		$("#overlay").append(WCompass.node);
		AppEvent.on(player, "placeReady", function(pe) { WCompass.placeReady(pe);});
		AppEvent.on(player, "onProcess", function() { WCompass.process();});
		AppEvent.on(player, "BOTTOMBAR.TOGGLE", function(w) { WCompass.toggle(w);});

//		player.devauthtoken = WCompass.getCookie("devauthtoken");
		if (player.devauthtoken != undefined && player.devauthtoken != "") {
			WCompass.node.find(".compass").css("pointer-events", "all");
			WCompass.node.find(".rose").css("pointer-events", "all");
			WCompass.adjustnode = $("<div style='display:none;position:absolute;left:50%;bottom: 125px; transform:translateX(-50%); color:#ffffff;background-color:#000000aa;padding: 10px;'><a href='javascript:void(null);' class='ndec' data-step='5'>&laquo;</a> &nbsp; <a href='javascript:void(null);' class='ndec'  data-step='1'>&lt;</a> &nbsp; <a href='javascript:void(null);' class='nsave'>Z</a> &nbsp; <a href='javascript:void(null);' class='ninc' data-step='1'>&gt;</a> &nbsp; <a href='javascript:void(null);' class='ninc' data-step='5'>&raquo;</a></div>");
			WCompass.adjustnode.find("a").css("color", "#ffffff");
			WCompass.adjustnode.find("a").css("font-size", "20px");
			WCompass.adjustnode.find("a").css("pointer-events", "all");
			WCompass.adjustnode.find("a").css("display", "inline-block");
			WCompass.adjustnode.find("a").css("padding", "8px");
			$("#overlay").append(WCompass.adjustnode);

//			WCompass.node.find(".rose").on("click", function() {
			WCompass.node.on("click", function() {
				WCompass.adjustnode.toggle();
			});

			WCompass.adjustnode.find("a.ninc").on("click", function() {
				if (isNaN(parseFloat(player.currentView.properties.properties.north))) player.currentView.properties.properties.north = 0;
				player.currentView.properties.properties.north = parseInt(player.currentView.properties.properties.north) + parseInt($(this).data('step'));
				if (player.currentView.properties.properties.north > 360) player.currentView.properties.properties.north = player.currentView.properties.properties.north - 360;
				console.log(player.currentView.properties.properties.north);
				Gyroscope.reposition();
			});
			WCompass.adjustnode.find("a.ndec").on("click", function() {
				if (isNaN(parseFloat(player.currentView.properties.properties.north))) player.currentView.properties.properties.north = 0;
				player.currentView.properties.properties.north = parseInt(player.currentView.properties.properties.north) - parseInt($(this).data('step'));
				if (player.currentView.properties.properties.north < 0) player.currentView.properties.properties.north = 360 + player.currentView.properties.properties.north;
				console.log(player.currentView.properties.properties.north);
				Gyroscope.reposition();
			});
			
			WCompass.adjustnode.find("a.nsave").on("click", function() {
				$.getJSON("/panoupdate.php?north=" + player.currentView.properties.properties.north + "&id=" + player.ident, function() {
					WCompass.adjustnode.hide();
				});
			});
		}

		if (PROJECT.customer.ma_vr == "1") {
			if (player.offline) {
			//	WCompass.node.append("<div style='position: absolute;left: -45px;top:10px;border:1px solid #ffffff;border-radius: 100%;padding:6px;line-height:0px;;background-color:rgba(1,1,1,.1)'></div>");
			} else {
				WCompass.node.append("<div style='position: absolute;left: -45px;top:10px;border:1px solid #ffffff;border-radius: 100%;padding:6px;line-height:0px;;background-color:rgba(1,1,1,.1)'><a href='javascript:void(null);' onclick='WCompass.vrPopup()' title='" +TPL.lng("HTML5.vr.switch", "Włącz tryb gogli Virtual Reality") + "' data-speakgroup='TIPS' data-speak='HTML5.vr.switch' id='vrswitch' class='speaks' style='color:#ffffff;pointer-events:all;'><img src='/html5/assets/vr.png' width='28'></a></div>");
			}
//			WCompass.node.append("<div style='position: absolute;left: -45px;top:10px;border:1px solid #ffffff;border-radius: 100%;padding:6px;line-height:0px;;background-color:rgba(1,1,1,.1)'><a href='javascript:void(null);' onclick='sphereWebGLStatic.toggleStereo()' title='" +TPL.lng("HTML5.vr.switch", "Włącz tryb gogli Virtual Reality") + "' data-speakgroup='TIPS' data-speak='HTML5.vr.switch' id='vrswitch' class='speaks' style='color:#ffffff;pointer-events:all;'><img src='/html5/assets/vr.png' width='28'></a></div>");
			Menu.addBasicTab("iwindow", $("#vrswitch"));
		}

		SpeechManager.enableSpeech("#compass", ".speaks", 0, "TOPMENU");
	},

	vrPopup: function() {
		$("#overlay").append("<div class='vr-popup'><div class='vrp-header'><h3>Wybierz opcję:</h3><a href='javascript:void(null)' id='vro-close' onclick='WCompass.vrClose();' title='Zamknij okno VR'>&times;</a></div><a href='javascript:void(null)' onclick='WCompass.vrSelect(1)' id='vro1' title='Włącz symulację VR'><img src='/html5/assets/vro-1.png'><div><b>Symuluj VR</b>na swoim smartfonie.</div></a><a href='javascript:void(null)' onclick='WCompass.vrSelect(2)' id='vro2' title='Włącz gogle VR'><img src='/html5/assets/vro-2.png'><div><b>Google VR</b>Uruchom prezentację na googlach VR (musisz posiadać odpowiednie urządzenie).</div></a></div>");

		WCompass.tvroc = Menu.addBasicTab("iwindow", $("#vro-close"));
		WCompass.tvro1 = Menu.addBasicTab("iwindow", $("#vro1"));
		WCompass.tvro2 = Menu.addBasicTab("iwindow", $("#vro2"));

		//console.log(WCompass.tvro1);
		//console.log(WCompass.tvro2);
		//console.log(WCompass.tvroc);

		//sphereWebGLStatic.toggleStereo();
	},

	vrClose: function() {
		Tab.remove("iwindow", WCompass.tvro1.id);
		Tab.remove("iwindow", WCompass.tvro2.id);
		Tab.remove("iwindow", WCompass.tvroc.id);

		$(".vr-popup").remove();
	},

	vrSelect: function(o) {
		switch(o) {
			case 1:
				sphereWebGLStatic.toggleStereo();
			break;
			case 2:
				sphereWebGLStatic.self.vrEnable();
			break;
		}

		WCompass.vrClose();
	},

	placeReady: function(pe) {
		if (player.current.place_type == "panorama") {
			$("#compass").show();
		} else {
			$("#compass").hide();
		}
	},

	process: function() {
		if (player.current.place_type == "panorama" && player.currentView != undefined && player.currentView != null) {
			if (player.currentView.getRX == undefined) return;
			var cr = player.currentView.getRX();
			cr = (360 - cr) + 90;
			try {
				cr += parseFloat(player.current.properties.north);
			} catch(e) {

			} 
			cr = cr % 360;
			
			$("#carrow").css("transform", "rotate(" + cr + "deg)");
			if ((cr > 357 && cr < 361) || (cr < 3 && cr > -1)) $("#carrow").css("filter", "brightness(0.5) sepia(1) saturate(10000%)");
			else $("#carrow").css("filter", "none");
			//console.log(player.currentView.rx);
		}
	},

	toggle: function(w) {
		if (player.current.place_type == "panorama") {
			console.log("TOGGLE");
			if (w.display) $("#compass").show();
			else $("#compass").hide();
		}
	},

	showGyro: function() {
		WCompass.node.append("<div style='position: absolute;left: -95px;top:10px;border:1px solid #ffffff;border-radius: 100%;padding:6px;line-height:0px;background-color:rgba(1,1,1,.1)'><a href='javascript:void(null);' id='gyroswitch' style='color:#ffffff;pointer-events:all;'><img src='/html5/assets/gyroscope.png' width='28'></a></div>");
		$("#gyroswitch").click(function() {
			Gyroscope.startStop();
			if (Gyroscope.started) $("#gyroswitch").css("animation","kf_fullloopblinking 1.5s linear infinite");
			else $("#gyroswitch").css("animation","");
		});
	}
}

PluginManager.add(WCompass);